import React from 'react';
import {ActivityIndicator} from 'react-native';

import theme from '../../global/styles/theme';
import TextDefault from '../TextDefault';
import * as S from './styles';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

interface ButtonProps {
  title: string;
  onPress: () => void;
  height?: number;
  marginTop?: number;
  width?: string | number;
  isLoading?: boolean;
  fontSize?: number;
  fontFamily?: string;
  borderRadius?: number;
  backgroundColor?: string;
  fontColor?: string;
  border?: string;
  marginBottom?: number;
  borderColor?: string;
  plusIcon?: boolean;
  disabled?: boolean;
  style?: any;
  Icon?: any;
}

export default function Button({
  title,
  onPress,
  height,
  width,
  marginTop,
  isLoading,
  fontFamily,
  fontSize,
  borderRadius,
  backgroundColor,
  fontColor,
  border,
  marginBottom,
  borderColor,
  disabled,
  style,
  Icon,
}: ButtonProps) {
  const appTheme = useSelector((state: RootState) => state.config.appTheme);

  function renderButtonIcon() {
    if (isLoading) {
      return (
        <ActivityIndicator size="large" color={theme.colors(appTheme).white} />
      );
    }
    return (
      <S.Row>
        {Icon && Icon}
        <TextDefault
          text={title}
          fontSize={fontSize || 12}
          fontFamily={fontFamily || theme.fonts.family.opensans.regular}
          color={fontColor || theme.colors(appTheme).black[500]}
          marginLeft={Icon ? 5 : 0}
        />
      </S.Row>
    );
  }

  return (
    <S.ButtonArea
      width={width}
      height={height}
      onPress={onPress}
      marginTop={marginTop}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      border={border}
      marginBottom={marginBottom}
      disabled={disabled || isLoading}
      borderColor={borderColor}
      appTheme={appTheme}
      style={style}>
      {renderButtonIcon()}
    </S.ButtonArea>
  );
}
